import React from "react"

const FoodSafetyPolicy: React.FC = (): JSX.Element => {
  return (
    <section id="food-safety-policy" className="mb-8">
      <div className="space-y-6">
        <div>
          <h2 className="text-lg font-bold text-black mb-4">
            4. PHẠM VI SỬ DỤNG THÔNG TIN
          </h2>
          <div className="space-y-3 text-gray-800 text-sm leading-relaxed">
            <p>
              TuTiMi Coffee & Tea có thể sử dụng thông tin về bạn mà TuTiMi
              Coffee & Tea thu thập được theo nhiều cách thức khác nhau, bao
              gồm:
            </p>

            <ul className="space-y-1">
              <li>
                • Xử lý các giao dịch mua sản phẩm và sử dụng dịch vụ của bạn;
              </li>
              <li>
                • Tạo điều kiện thuận lợi cho các chức năng của trang web và các
                ứng dụng di động của TuTiMi Coffee & Tea;
              </li>
              <li>
                • Liên lạc với bạn về đơn đặt hàng, giao dịch mua hàng, hoàn trả
                hàng, tài khoản, các chương trình;
              </li>
              <li>
                • Trả lời các thắc mắc về dịch vụ khách hàng và yêu cầu về thông
                tin của bạn;
              </li>
              <li>
                • Đăng ý kiến hoặc phát biểu của bạn trên các trang web của
                TuTiMi Coffee & Tea;
              </li>
              <li>
                • Gửi cho bạn các chương trình khuyến mại, quảng cáo, các cuộc
                thi, trò chơi, bản tin mang lại lợi ích cho bạn;
              </li>
              <li>
                • Duy trì và cải thiện các trang web và các sản phẩm và các dịch
                vụ mà TuTiMi Coffee & Tea cung cấp;
              </li>
              <li>
                • Phát hiện, ngăn chặn và điều tra vi phạm an ninh và gian lận;
              </li>
              <li>
                • Duy trì hồ sơ lưu trữ chính xác và phù hợp cho mục đích quản
                lý nội bộ.
              </li>
            </ul>
          </div>
        </div>

        <div>
          <h2 className="text-lg font-bold text-black mb-4">
            5. CAM KẾT BẢO MẬT THÔNG TIN CÁ NHÂN KHÁCH HÀNG
          </h2>
          <div className="space-y-3 text-gray-800 text-sm leading-relaxed">
            <p>
              Thông tin cá nhân, thông tin riêng của người sử dụng được thu
              thập, lưu trữ và bảo vệ một cách nghiêm túc, chính xác và bảo mật.
            </p>
            <p>
              TuTiMi Coffee & Tea chỉ tập hợp lại các thông tin cá nhân trong
              phạm vi phù hợp và cần thiết cho mục đích thương mại đúng đắn của
              TuTiMi Coffee & Tea. Và TuTiMi Coffee & Tea duy trì các biện pháp
              thích hợp nhằm đảm bảo tính an toàn, nguyên vẹn, độ chính xác, và
              tính bảo mật của những thông tin mà người sử dụng đã cung cấp.
            </p>
            <p>
              TuTiMi Coffee & Tea thiết lập những phần mềm thu thập, lưu trữ
              thông tin riêng biệt và được thực hiện duy nhất bởi hệ thống máy
              chủ và hệ thống máy chủ dự phòng của TuTiMi Coffee & Tea. Trong
              khi TuTiMi Coffee & Tea sử dụng các công nghệ và quy trình an ninh
              để giúp bảo vệ thông tin cá nhân của bạn, TuTiMi Coffee & Tea
              không thể đảm bảo hệ thống hoặc mạng an toàn 100%.
            </p>
          </div>
        </div>

        <div>
          <h2 className="text-lg font-bold text-black mb-4">
            6. THÔNG TIN ĐƠN VỊ THU THẬP THÔNG TIN
          </h2>
          <div className="space-y-3 text-gray-800 text-sm leading-relaxed">
            <p className="font-semibold text-black text-sm">
              CÔNG TY TUTIMI COFFEE & TEA
            </p>
            <p>
              Địa chỉ trụ sở: 39/50 Đặng Thùy Trâm, P.13, Q. Bình Thạnh, TP.HCM
            </p>
            <p>Điện thoại: 0901837263</p>
            <p>Email: tutimicoffee@gmail.com</p>
          </div>
        </div>

        <div>
          <h2 className="text-lg font-bold text-black mb-4">
            7. THÔNG TIN VỀ DỮ LIỆU KHUÔN MẶT (FACE DATA)
          </h2>
          <div className="space-y-3 text-gray-800 text-sm leading-relaxed">
            <p>
              Ứng dụng App chấm công có sử dụng camera của thiết bị để chụp ảnh
              khuôn mặt người dùng trong quá trình chấm công (check-in/check-out)
              nhằm xác minh danh tính của người dùng.
            </p>

            <p className="font-semibold text-black">Phạm vi thu thập:</p>
            <ul className="space-y-1 ml-4">
              <li>
                • Ứng dụng chỉ chụp một ảnh tĩnh của khuôn mặt người dùng tại
                thời điểm thực hiện chấm công.
              </li>
              <li>
                • Ứng dụng không thu thập, xử lý hoặc lưu trữ dữ liệu sinh trắc
                học (biometric data) hoặc các đặc trưng khuôn mặt dưới dạng mẫu
                nhận diện (face template).
              </li>
            </ul>

            <p className="font-semibold text-black">Mục đích sử dụng:</p>
            <ul className="space-y-1 ml-4">
              <li>
                • Ảnh khuôn mặt được sử dụng duy nhất để xác minh nhân viên
                thực hiện hành động chấm công.
              </li>
              <li>
                • Ảnh này chỉ phục vụ cho bộ phận quản trị nhân sự (HR) của
                doanh nghiệp hoặc người quản lý tài khoản doanh nghiệp trên hệ
                thống.
              </li>
            </ul>

            <p className="font-semibold text-black">Lưu trữ và bảo mật:</p>
            <ul className="space-y-1 ml-4">
              <li>
                • Ảnh khuôn mặt được tải lên máy chủ bảo mật của TuTiMi thông
                qua giao thức HTTPS/TLS mã hóa toàn bộ dữ liệu truyền tải.
              </li>
              <li>
                • Dữ liệu được lưu trữ trên hệ thống máy chủ riêng và chỉ có
                quản trị viên được ủy quyền mới có quyền truy cập.
              </li>
            </ul>

            <p className="font-semibold text-black">Chia sẻ với bên thứ ba:</p>
            <ul className="space-y-1 ml-4">
              <li>
                • TuTiMi không chia sẻ dữ liệu khuôn mặt với bất kỳ bên thứ ba
                nào.
              </li>
              <li>
                • Dữ liệu này không được sử dụng cho quảng cáo, phân tích hành
                vi hay mục đích thương mại khác.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FoodSafetyPolicy
